// import { useState, useEffect } from "react";
// import { RadioGroup } from "@headlessui/react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { Button, Divider, CircularProgress } from "@mui/material";
// import QuantityInput from "../../Common/QuantityInput";
// import { findProductById } from "../../../../Redux/Customers/Product/Action";
// import { addItemToCart } from "../../../../Redux/Customers/Cart/Action";
// import { getAllReviews } from "../../../../Redux/Customers/Review/Action";
// import HomeProductCard from "../../Home/HomeProductCard";
// import DetailsBox from "./DetailsBox";
// import { gounsPage1 } from "../../../../Data/Gouns/gouns";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import AuthModal from "../../Auth/AuthModal";
// import { addItemToWishList } from "../../../../Redux/Customers/WishList/Action";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
// import { IconButton } from "@mui/material";
// import { updateCartItem } from "../../../../Redux/Customers/Cart/Action";
// import benefits from "./part_2_eco.png";
// const product = {
//   name: "Lata Embroidery Khadi Saree",
//   price: "₹996",
//   href: "#",
//   breadcrumbs: [
//     { id: 1, name: "Women", href: "#" },
//     { id: 2, name: "Khadi", href: "#" },
//   ],
//   images: [
//     {
//       src: "https://tailwindui.com/img/ecommerce-images/product-page-02-secondary-product-shot.jpg",
//       alt: "Two each of gray, white, and black shirts laying flat.",
//     },
//     {
//       src: "https://tailwindui.com/img/ecommerce-images/product-page-02-tertiary-product-shot-01.jpg",
//       alt: "Model wearing plain black basic tee.",
//     },
//     {
//       src: "https://tailwindui.com/img/ecommerce-images/product-page-02-tertiary-product-shot-02.jpg",
//       alt: "Model wearing plain gray basic tee.",
//     },
//     {
//       src: "https://tailwindui.com/img/ecommerce-images/product-page-02-featured-product-shot.jpg",
//       alt: "Model wearing plain white basic tee.",
//     },
//   ],
// };


// const productDescription =
//   "This captivating bronze crystal gown is a showstopper, ideal for weddings, sangeet, and cocktail events...";

// function classNames(...classes) {
//   return classes.filter(Boolean).join(" ");
// }

// export default function ProductDetails() {
//   const [selectedSize, setSelectedSize] = useState();
//   const [activeImage, setActiveImage] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [openAuthModal, setOpenAuthModal] = useState(false);
//   const [selectedColor, setSelectedColor] = useState(null);
//   const [currentImages, setCurrentImages] = useState([]);
//   const [isAddingToCart, setIsAddingToCart] = useState(false);
//   const [quantity, setQuantity] = useState(1);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { customersProduct, auth } = useSelector((store) => store);
//   const { productId } = useParams();
//   const jwt = localStorage.getItem("jwt");

//   const handleClose = () => setOpenAuthModal(false);

//   const handleSetActiveImage = (image) => {
//     setActiveImage(image);
//   };
//   const faqList = customersProduct.product?.faq || [];
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!jwt) {
//       setOpenAuthModal(true);
//       return;
//     }

//     if (!productId) {
//       toast.error("Product not found");
//       return;
//     }

//     setIsAddingToCart(true);

//     try {
//       const data = {
//         productId,
//         size: selectedSize?.name || "ONE_SIZE",
//         quantity, // sending latest quantity selected
//       };

//       await dispatch(addItemToCart({ data, jwt }));
//       toast.success("Item added to cart!");
//       // Optionally redirect to cart:
//       // navigate("/cart");
//     } catch (error) {
//       toast.error("Failed to add to cart");
//       console.error("Add to cart error:", error);
//     } finally {
//       setIsAddingToCart(false);
//     }
//   };

//   const handleAddToWishlist = () => {
//     if (!jwt) {
//       setOpenAuthModal(true);
//       return;
//     }

//     const wishlistData = {
//       productId,
//       size: selectedSize?.name || null,
//     };

//     dispatch(addItemToWishList({ data: wishlistData, jwt }))
//       .then(() => toast.success("Item added to wishlist!"))
//       .catch(() => toast.error("Failed to add to wishlist"));
//   };

//   useEffect(() => {
//     const defaultColorVariant =
//       customersProduct.product?.colorVariants?.[0] || null;
//     setSelectedColor(defaultColorVariant);
//   }, [customersProduct.product]);

//   useEffect(() => {
//     if (selectedColor) {
//       setCurrentImages(selectedColor.images || []);
//       setActiveImage(selectedColor.images?.[0] || null);
//     }
//   }, [selectedColor]);

//   useEffect(() => {
//     const data = { productId, jwt };
//     setLoading(true);
//     Promise.all([
//       dispatch(findProductById(data)),
//       dispatch(getAllReviews(productId)),
//     ]).finally(() => setLoading(false));
//   }, [productId]);

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <div className="bg-white lg:px-20">
//       <div className="pt-6">
//         {/* <nav aria-label="Breadcrumb">
//           <ol className="mx-auto flex max-w-2xl items-center space-x-2 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
//             {product.breadcrumbs.map((breadcrumb) => (
//               <li key={breadcrumb.id}>
//                 <div className="flex items-center">
//                   <a
//                     href="/"
//                     className="mr-2 text-sm font-medium text-gray-900"
//                   >
//                     {breadcrumb.name}
//                   </a>
//                   <svg
//                     width={16}
//                     height={20}
//                     fill="currentColor"
//                     className="h-5 w-4 text-gray-300"
//                   >
//                     <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
//                   </svg>
//                 </div>
//               </li>
//             ))}
//             <li className="text-sm">
//               <a
//                 href={product.href}
//                 className="font-medium text-gray-500 hover:text-gray-600"
//               >
//                 {product.name}
//               </a>
//             </li>
//           </ol>
//         </nav> */}

//         <section className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-2 px-4 pt-10">
//           {/* Left image preview */}
//           <div className="flex flex-col items-center">
//             {(customersProduct.product?.colorVariants?.[0]?.images || []).map(
//               (image, i) => (
//                 <div
//                   key={i}
//                   className="overflow-hidden rounded-lg max-w-[50rem] max-h-[50rem] mb-5"
//                 >
//                   <img
//                     src={image.url}
//                     alt={image.label}
//                     className="h-full w-full object-cover object-center"
//                   />
//                 </div>
//               )
//             )}
//           </div>

//           {/* Right content */}
//           <div className="mx-auto max-w-2xl px-4 pb-16 sm:px-6 lg:max-w-7xl lg:px-8 lg:pb-24">
//             <h1 className="text-2xl font-bold text-gray-900">
//               {customersProduct.product?.title}
//             </h1>

//             <div className="flex mt-5">
//               {[...Array(5)].map((_, i) => (
//                 <svg
//                   key={i}
//                   className={`w-8 h-8 ${i < 5 ? "text-yellow-400" : "text-gray-300"
//                     }`}
//                   fill="currentColor"
//                   viewBox="0 0 20 20"
//                 >
//                   <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                 </svg>
//               ))}
//             </div>

//             <div className="my-6">
//               <p className="text-2xl font-semibold text-gray-800">
//                 Rs. {customersProduct.product?.discountedPrice}
//               </p>
//               <p className="text-sm mt-1 text-gray-500">
//                 Total: Includes shipping calculated at checkout.
//               </p>
//             </div>

//             <div className="flex items-center gap-4 mb-6">
//               <div className="flex items-center border rounded">
//                 <button
//                   className="w-8 h-8 border-r"
//                   onClick={() => setQuantity(Math.max(1, quantity - 1))}
//                 >
//                   -
//                 </button>
//                 <span className="w-10 text-center">{quantity}</span>
//                 <button
//                   className="w-8 h-8 border-l"
//                   onClick={() => setQuantity(quantity + 1)}
//                 >
//                   +
//                 </button>
//               </div>
//               {/* <button
//                 className="addcart_btn  bg-black hover:bg-gray-800"

//               >
//                 <span>Out of Stock</span>
//               </button> */}
//               <button
//                 className="addcart_btn  bg-black hover:bg-gray-800"
//                 onClick={handleSubmit}
//               >
//                 <span>Add To Cart</span>
//               </button>
//             </div>

//             <Divider className="my-6" />

//             <img
//               src={benefits}
//               alt="Bonvie Benefits"
//               width="100%"
//               className="my-6 rounded-lg"
//             />

//             <p className="text-gray-700">
//               {customersProduct.product?.description}
//             </p>

//             <div className="py-10 border-t">
//               <h1 className="text-2xl font-semibold text-gray-800">FAQ</h1>
//               {faqList.map((faq) => (
//                 <DetailsBox
//                   key={faq._id}
//                   title={<span className="font-bold">{faq.question}</span>}
//                   content={<span className="font-normal">{faq.answer}</span>}
//                 />
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* <section className="pt-10">
//           <h1 className="py-5 text-xl font-bold">Similar Products</h1>
//           <div className="flex flex-wrap space-y-5">
//             {gounsPage1.map((item, i) => (
//               <HomeProductCard key={i} product={item} />
//             ))}
//           </div>
//         </section> */}
//       </div>

//       <ToastContainer position="top-right" autoClose={3000} />
//       <AuthModal handleClose={handleClose} open={openAuthModal} />
//     </div>
//   );
// }



// import { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { Divider, CircularProgress } from "@mui/material";
// import { findProductById } from "../../../../Redux/Customers/Product/Action";
// import { addItemToCart } from "../../../../Redux/Customers/Cart/Action";
// import { getAllReviews } from "../../../../Redux/Customers/Review/Action";
// import DetailsBox from "./DetailsBox";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import AuthModal from "../../Auth/AuthModal";
// import { addItemToWishList } from "../../../../Redux/Customers/WishList/Action";
// import benefits from "./part_2_eco.png";
// import RecommendedSection from "../../../../Pages/SideBar/RecommendedSection";
// import ReviewSlider from "../../../../Pages/CutomerReview";
// import ProductReviewCard from "./ProductReviewCard";

// export default function ProductDetails() {
//   const [selectedSize, setSelectedSize] = useState();
//   const [activeImage, setActiveImage] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [openAuthModal, setOpenAuthModal] = useState(false);
//   const [selectedColor, setSelectedColor] = useState(null);
//   const [currentImages, setCurrentImages] = useState([]);
//   const [isAddingToCart, setIsAddingToCart] = useState(false);
//   const [quantity, setQuantity] = useState(1);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { customersProduct } = useSelector((store) => store);
//   const { productId } = useParams();
//   const jwt = localStorage.getItem("jwt");

//   const handleClose = () => setOpenAuthModal(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!jwt) {
//       setOpenAuthModal(true);
//       return;
//     }

//     if (!productId) {
//       toast.error("Product not found");
//       return;
//     }

//     setIsAddingToCart(true);

//     try {
//       const data = {
//         productId,
//         size: selectedSize?.name || "ONE_SIZE",
//         quantity,
//       };

//       await dispatch(addItemToCart({ data, jwt }));
//       toast.success("Item added to cart!");
//     } catch (error) {
//       toast.error("Failed to add to cart");
//       console.error("Add to cart error:", error);
//     } finally {
//       setIsAddingToCart(false);
//     }
//   };

//   const handleAddToWishlist = () => {
//     if (!jwt) {
//       setOpenAuthModal(true);
//       return;
//     }

//     const wishlistData = {
//       productId,
//       size: selectedSize?.name || null,
//     };

//     dispatch(addItemToWishList({ data: wishlistData, jwt }))
//       .then(() => toast.success("Item added to wishlist!"))
//       .catch(() => toast.error("Failed to add to wishlist"));
//   };

//   useEffect(() => {
//     const defaultColorVariant =
//       customersProduct.product?.colorVariants?.[0] || null;
//     setSelectedColor(defaultColorVariant);
//   }, [customersProduct.product]);

//   useEffect(() => {
//     if (selectedColor) {
//       setCurrentImages(selectedColor.images || []);
//       setActiveImage(selectedColor.images?.[0] || null);
//     }
//   }, [selectedColor]);

//   useEffect(() => {
//     const data = { productId, jwt };
//     setLoading(true);
//     Promise.all([
//       dispatch(findProductById(data)),
//       dispatch(getAllReviews(productId)),
//     ]).finally(() => setLoading(false));
//   }, [productId]);

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <CircularProgress />
//       </div>
//     );
//   }

//   const product = customersProduct.product;
//   const faqList = product?.faq || [];
//   const isOutOfStock = !product?.quantity || product?.quantity <= 0;

//   return (
//     <div className="bg-white lg:px-20">
//       <div className="pt-6">
//         <section className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-2 px-4 pt-10">
//           {/* Left image preview */}
//           <div className="flex flex-col items-center">
//             {(product?.colorVariants?.[0]?.images || []).map((image, i) => (
//               <div
//                 key={i}
//                 className="overflow-hidden rounded-lg max-w-[50rem] max-h-[50rem] mb-5"
//               >
//                 <img
//                   src={image.url}
//                   alt={image.label}
//                   className="h-full w-full object-cover object-center"
//                 />
//               </div>
//             ))}
//           </div>

//           {/* Right content */}
//           <div className="mx-auto max-w-2xl px-4 pb-16 sm:px-6 lg:max-w-7xl lg:px-8 lg:pb-24">
//             <h1 className="text-2xl font-bold text-gray-900">
//               {product?.title}
//             </h1>

//             <div className="flex mt-5">
//               {[...Array(5)].map((_, i) => (
//                 <svg
//                   key={i}
//                   className={`w-8 h-8 ${i < 5 ? "text-yellow-400" : "text-gray-300"
//                     }`}
//                   fill="currentColor"
//                   viewBox="0 0 20 20"
//                 >
//                   <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                 </svg>
//               ))}
//             </div>

//             <div className="my-6">
//               <p className="text-2xl font-semibold text-gray-800">
//                 Rs. {product?.discountedPrice}
//               </p>
//               <p className="text-sm mt-1 text-gray-500">
//                 Total: Includes shipping calculated at checkout.
//               </p>
//             </div>

//             {/* Quantity + Cart */}
//             <div className="flex items-center gap-4 mb-6">
//               {isOutOfStock ? (
//                 <button
//                   className="addcart_btn bg-gray-400 cursor-not-allowed"
//                   disabled
//                 >
//                   <span>Out of Stock</span>
//                 </button>
//               ) : (
//                 <>
//                   <div className="flex items-center border rounded">
//                     <button
//                       className="w-8 h-8 border-r"
//                       onClick={() => setQuantity(Math.max(1, quantity - 1))}
//                     >
//                       -
//                     </button>
//                     <span className="w-10 text-center">{quantity}</span>
//                     <button
//                       className="w-8 h-8 border-l"
//                       onClick={() => setQuantity(quantity + 1)}
//                     >
//                       +
//                     </button>
//                   </div>
//                   <button
//                     className="addcart_btn bg-black hover:bg-gray-800"
//                     onClick={handleSubmit}
//                   >
//                     <span>{isAddingToCart ? "Adding..." : "Add To Cart"}</span>
//                   </button>
//                 </>
//               )}
//             </div>

//             <Divider className="my-6" />

//             <img
//               src={benefits}
//               alt="Bonvie Benefits"
//               width="100%"
//               className="my-6 rounded-lg"
//             />

//             <p className="text-gray-700">{product?.description}</p>

//             <div className="py-10 border-t">
//               <h1 className="text-2xl font-semibold text-gray-800">FAQ</h1>
//               {faqList.map((faq) => (
//                 <DetailsBox
//                   key={faq._id}
//                   title={<span className="font-bold">{faq.question}</span>}
//                   content={<span className="font-normal">{faq.answer}</span>}
//                 />
//               ))}
//             </div>
//           </div>
//         </section>
//       </div>
//       <ToastContainer position="top-right" autoClose={3000} />
//       <AuthModal handleClose={handleClose} open={openAuthModal} />
//     </div>
//   );
// }


import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Divider, CircularProgress } from "@mui/material";
import { findProductById } from "../../../../Redux/Customers/Product/Action";
import { addItemToCart } from "../../../../Redux/Customers/Cart/Action";
import { getAllReviews } from "../../../../Redux/Customers/Review/Action";
import DetailsBox from "./DetailsBox";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthModal from "../../Auth/AuthModal";
import { addItemToWishList } from "../../../../Redux/Customers/WishList/Action";
import benefits from "./part_2_eco.png";
import ProductReviewCard from "./ProductReviewCard";
import ReviewSlider from "../../../../Pages/CutomerReview";

export default function ProductDetails() {
  const [selectedSize, setSelectedSize] = useState();
  const [activeImage, setActiveImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openAuthModal, setOpenAuthModal] = useState(false);
  const [selectedColor, setSelectedColor] = useState(null);
  const [currentImages, setCurrentImages] = useState([]);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { customersProduct, review } = useSelector((store) => store);
  const { productId } = useParams();
  const jwt = localStorage.getItem("jwt");

  const handleClose = () => setOpenAuthModal(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!jwt) {
      setOpenAuthModal(true);
      return;
    }

    if (!productId) {
      toast.error("Product not found");
      return;
    }

    setIsAddingToCart(true);

    try {
      const data = {
        productId,
        size: selectedSize?.name || "ONE_SIZE",
        quantity,
      };

      await dispatch(addItemToCart({ data, jwt }));
      toast.success("Item added to cart!");
    } catch (error) {
      toast.error("Failed to add to cart");
      console.error("Add to cart error:", error);
    } finally {
      setIsAddingToCart(false);
    }
  };

  const handleAddToWishlist = () => {
    if (!jwt) {
      setOpenAuthModal(true);
      return;
    }

    const wishlistData = {
      productId,
      size: selectedSize?.name || null,
    };

    dispatch(addItemToWishList({ data: wishlistData, jwt }))
      .then(() => toast.success("Item added to wishlist!"))
      .catch(() => toast.error("Failed to add to wishlist"));
  };

  useEffect(() => {
    const defaultColorVariant =
      customersProduct.product?.colorVariants?.[0] || null;
    setSelectedColor(defaultColorVariant);
  }, [customersProduct.product]);

  useEffect(() => {
    if (selectedColor) {
      setCurrentImages(selectedColor.images || []);
      setActiveImage(selectedColor.images?.[0] || null);
    }
  }, [selectedColor]);

  useEffect(() => {
    const data = { productId, jwt };
    setLoading(true);
    Promise.all([
      dispatch(findProductById(data)),
      dispatch(getAllReviews(productId)),
    ]).finally(() => setLoading(false));
  }, [productId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <CircularProgress />
      </div>
    );
  }

  const product = customersProduct.product;
  const faqList = product?.faq || [];
  const isOutOfStock = !product?.quantity || product?.quantity <= 0;
  console.log(review, "11111111111111")
  // ✅ Reviews list from Redux
  const reviews = review?.reviews || [];

  return (
    <div className="bg-white lg:px-20">
      <div className="pt-6">
        <section className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-2 px-4 pt-10">
          {/* Left image preview */}
          <div className="flex flex-col items-center">
            {(product?.colorVariants?.[0]?.images || []).map((image, i) => (
              <div
                key={i}
                className="overflow-hidden rounded-lg max-w-[50rem] max-h-[50rem] mb-5"
              >
                <img
                  src={image.url}
                  alt={image.label}
                  className="h-full w-full object-cover object-center"
                />
              </div>
            ))}
          </div>

          {/* Right content */}
          <div className="mx-auto max-w-2xl px-4 pb-16 sm:px-6 lg:max-w-7xl lg:px-8 lg:pb-24">
            <h1 className="text-2xl font-bold text-gray-900">
              {product?.title}
            </h1>

            <div className="flex mt-5">
              {[...Array(5)].map((_, i) => (
                <svg
                  key={i}
                  className={`w-8 h-8 ${i < 5 ? "text-yellow-400" : "text-gray-300"
                    }`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>

            <div className="my-6">
              <p className="text-2xl font-semibold text-gray-800">
                Rs. {product?.discountedPrice}
              </p>
              <p className="text-sm mt-1 text-gray-500">
                Total: Includes shipping calculated at checkout.
              </p>
            </div>

            {/* Quantity + Cart */}
            <div className="flex items-center gap-4 mb-6">
              {isOutOfStock ? (
                <button
                  className="addcart_btn bg-gray-400 cursor-not-allowed"
                  disabled
                >
                  <span>Out of Stock</span>
                </button>
              ) : (
                <>
                  <div className="flex items-center border rounded">
                    <button
                      className="w-8 h-8 border-r"
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    >
                      -
                    </button>
                    <span className="w-10 text-center">{quantity}</span>
                    <button
                      className="w-8 h-8 border-l"
                      onClick={() => setQuantity(quantity + 1)}
                    >
                      +
                    </button>
                  </div>
                  <button
                    className="addcart_btn bg-black hover:bg-gray-800"
                    onClick={handleSubmit}
                  >
                    <span>{isAddingToCart ? "Adding..." : "Add To Cart"}</span>
                  </button>
                </>
              )}
            </div>

            <Divider className="my-6" />

            <img
              src={benefits}
              alt="Bonvie Benefits"
              width="100%"
              className="my-6 rounded-lg"
            />

            <p className="text-gray-700">{product?.description}</p>

            {/* FAQ Section */}
            <div className="py-10 border-t">
              <h1 className="text-2xl font-semibold text-gray-800">FAQ</h1>
              {faqList.map((faq) => (
                <DetailsBox
                  key={faq._id}
                  title={<span className="font-bold">{faq.question}</span>}
                  content={<span className="font-normal">{faq.answer}</span>}
                />
              ))}
            </div>
            <ProductReviewCard items={reviews} />
            {/* Reviews Section */}
            {/* <div className="py-10 border-t">
              <h1 className="text-2xl font-semibold text-gray-800 mb-4">
                Customer Reviews
              </h1>
              {reviews.length === 0 ? (
                <p className="text-gray-500">No reviews yet.</p>
              ) : (
                <div className="space-y-4">
                  {reviews.map((review) => (
                    <div
                      key={review._id}
                      className="border p-4 rounded-md shadow-sm"
                    >
                      <p className="text-gray-800">{review.review}</p>
                      <p className="text-sm text-gray-600 mt-2">
                        - {review.user?.firstName} {review.user?.lastName} (
                        {new Date(review.createdAt).toLocaleDateString()})
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div> */}
          </div>
        </section>
      </div>

      {/* <ProductReviewCard item={reviews} /> */}
      <ToastContainer position="top-right" autoClose={3000} />
      <AuthModal handleClose={handleClose} open={openAuthModal} />
    </div>
  );
}
